/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Assignment_Updated_ToastInputs */

const en_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assignment updated successfully`)
};

const fr_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affectation mise a jour avec succes`)
};

const de_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufgabe erfolgreich aktualisiert`)
};

const it_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assegnazione aggiornata con successo`)
};

const ru_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задание успешно обновлено.`)
};

const es_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asignación actualizada exitosamente`)
};

const zh_cn2_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`任务已成功更新`)
};

const ja_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`課題が正常に更新されました`)
};

const hi_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असाइनमेंट सफलतापूर्वक अपडेट हो गया`)
};

const pt_pt2_explorer_info_assignment_updated_toast = /** @type {(inputs: Explorer_Info_Assignment_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa atualizada com sucesso`)
};

/**
* | output |
* | --- |
* | "Assignment updated successfully" |
*
* @param {Explorer_Info_Assignment_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_assignment_updated_toast = /** @type {((inputs?: Explorer_Info_Assignment_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Assignment_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_assignment_updated_toast(inputs)
	if (locale === "de") return de_explorer_info_assignment_updated_toast(inputs)
	if (locale === "it") return it_explorer_info_assignment_updated_toast(inputs)
	if (locale === "ru") return ru_explorer_info_assignment_updated_toast(inputs)
	if (locale === "es") return es_explorer_info_assignment_updated_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_assignment_updated_toast(inputs)
	if (locale === "ja") return ja_explorer_info_assignment_updated_toast(inputs)
	if (locale === "hi") return hi_explorer_info_assignment_updated_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_assignment_updated_toast(inputs)
	return en_explorer_info_assignment_updated_toast(inputs)
});